module.exports = __webpack_public_path__ + "media/images/marketing/app_video_thumbnail2-d526080c3df3d6e9081113ca4d9d9dc68ca30aad9328d0cb4659498137f44e67.jpg";